import { createContext } from "react";

import type { BrazeDashboardConfigContextType } from "./types";

// now that this is used in production, @lib/config is not defined in time, and is undefined. We have to use the window.brazeDashboardConfig directly
export const BrazeDashboardConfigContext = createContext<BrazeDashboardConfigContextType>([
  window.brazeDashboardConfig,
  () => {
    console.error("attempting to set brazeDashboardConfig from outside of a ContextProvider");
  },
]);
